import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=2eabc951&"
import script from "./IButton.vue?vue&type=script&lang=js&"
export * from "./IButton.vue?vue&type=script&lang=js&"
import style0 from "./IButton.vue?vue&type=style&index=0&id=2eabc951&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports